<template>
  <div class="app-container">
    <el-card v-if="rowItem">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">基本信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="讲师名称">{{rowItem.realName}}</el-descriptions-item>
        <el-descriptions-item label="性别">{{rowItem.sex === 1?'男':(rowItem.sex === 2?'女':'')}}</el-descriptions-item>
        <el-descriptions-item label="头像"><el-image style="width: 50px; height: 50px" :src="rowItem.profilePhotoMini" :preview-src-list="[rowItem.profilePhotoMini]"></el-image></el-descriptions-item>
        <el-descriptions-item label="形象图"><el-image style="width: 50px; height: 50px" :src="rowItem.profilePhoto" :preview-src-list="[rowItem.profilePhoto]"></el-image></el-descriptions-item>
        <el-descriptions-item label="手机号">{{rowItem.mobile}}</el-descriptions-item>
        <el-descriptions-item label="讲师等级">{{rowItem.levelName}}</el-descriptions-item>
        <el-descriptions-item label="身份描述">{{rowItem.identityTag}}</el-descriptions-item>
        <el-descriptions-item label="页面排序">{{rowItem.orderNo}}</el-descriptions-item>
        <el-descriptions-item label="个人简介">{{rowItem.profileDesc}}</el-descriptions-item>
        <el-descriptions-item label="课程数量">{{rowItem.courseCount}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{rowItem.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{rowItem.isEnable?'启用':'禁用'}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import lecturerApi from '@/api/course/lecturer'
export default {
  props: ['rowItem', 'isCourse'],
  data() {
    return {
      form: null,
    }
  },
  created() {
    if (this.isCourse) {
      this.getLecturerShow()
    }

  },
  methods: {
    getLecturerShow() {
      lecturerApi.fetchById(this.rowItem.lecturerId).then(res => {
        this.rowItem = res.data;
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}

.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
</style>
